export default {
  'engagement_active_title': '活跃',

  'engagement_active_activeUsers_tab': '基础分析',
  'engagement_active_onlineAnalysis_tab': '在线分析',
  'engagement_active_activeDegree_tab': '活跃度分析',
  'engagement_active_activeUsers_date': '日期',
  // au
  'engagement_active_activeUsers_day_au_title': '日活跃',
  'engagement_active_activeUsers_day_au_legend1': '当日',
  'engagement_active_activeUsers_day_au_legend2': '上周同期',
  'engagement_active_activeUsers_day_au_legend3': '上周同期',
  'engagement_active_activeUsers_week_au_title': '周活跃',
  'engagement_active_activeUsers_week_au_legend1': '当周',
  'engagement_active_activeUsers_week_au_legend2': '上月同期',
  'engagement_active_activeUsers_week_au_legend3': '上月同期',
  'engagement_active_activeUsers_month_au_title': '月活跃',
  'engagement_active_activeUsers_month_au_legend1': '当月',
  'engagement_active_activeUsers_month_au_legend2': '去年同期',
  'engagement_active_activeUsers_month_au_legend3': '去年同期',
  // pcu and acu
  'engagement_active_activeUsers_pcu_acu_title': '最高同时在线&平均同时在线',
  'engagement_active_activeUsers_pcu_acu_legend1': '最高同时在线',
  'engagement_active_activeUsers_pcu_acu_legend2': '平均同时在线',
  // dau breakdown
  'engagement_active_activeUsers_day_au_breakdown_title': '日活跃构成',
  'engagement_active_activeUsers_day_au_breakdown_sum_row': '日活跃',
  'engagement_active_activeUsers_day_au_breakdown_legend1': '日活跃',
  'engagement_active_activeUsers_day_au_breakdown_legend2': '新进用户',
  'engagement_active_activeUsers_day_au_breakdown_legend3': '留存用户',
  'engagement_active_activeUsers_day_au_breakdown_legend4': '回流用户',

  'engagement_active_activeUsers_week_au_breakdown_title': '周活跃构成',
  'engagement_active_activeUsers_week_au_breakdown_sum_row': '周活跃',
  'engagement_active_activeUsers_week_au_breakdown_legend1': '周活跃',
  'engagement_active_activeUsers_week_au_breakdown_legend2': '新进用户',
  'engagement_active_activeUsers_week_au_breakdown_legend3': '留存用户',
  'engagement_active_activeUsers_week_au_breakdown_legend4': '回流用户',

  'engagement_active_activeUsers_month_au_breakdown_title': '月活跃构成',

  'engagement_active_activeUsers_breakdown_dau': '日活跃用户',
  'engagement_active_activeUsers_breakdown_wau': '周活跃用户',
  'engagement_active_activeUsers_breakdown_mau': '月活跃用户',

  'engagement_active_activeUsers_dau_of_top_10_countries': '日活跃用户 Top 10 国家',
  'engagement_active_activeUsers_wau_of_top_10_countries': '周活跃用户 Top 10 国家',
  'engagement_active_activeUsers_mau_of_top_10_countries': '月活跃用户 Top 10 国家',

  'engagement_active_activeUsers_dau_of_top_10_regions': '日活跃用户 Top 10 区域',
  'engagement_active_activeUsers_wau_of_top_10_regions': '周活跃用户 Top 10 区域',
  'engagement_active_activeUsers_mau_of_top_10_regions': '月活跃用户 Top 10 区域',

  'engagement_active_activeUsers_dau_of_top_10_zones': '日活跃用户 Top 10 区服',
  'engagement_active_activeUsers_wau_of_top_10_zones': '周活跃用户 Top 10 区服',
  'engagement_active_activeUsers_mau_of_top_10_zones': '月活跃用户 Top 10 区服',


  'engagement_active_activeUsers_month_au_breakdown_sum_row': '月活跃',
  'engagement_active_activeUsers_month_au_breakdown_legend1': '月活跃',
  'engagement_active_activeUsers_month_au_breakdown_legend2': '新进用户',
  'engagement_active_activeUsers_month_au_breakdown_legend3': '留存用户',
  'engagement_active_activeUsers_month_au_breakdown_legend4': '回流用户',
  // dau channel distribution
  'engagement_active_activeUsers_day_channel_distribution_title': '日活跃用户渠道构成',
  'engagement_active_activeUsers_week_channel_distribution_title': '周活跃用户渠道构成',
  'engagement_active_activeUsers_month_channel_distribution_title': '月活跃用户渠道构成',
  // dau platform distribution
  'engagement_active_activeUsers_day_platform_distribution_title': '日活跃用户平台构成',
  'engagement_active_activeUsers_week_platform_distribution_title': '周活跃用户平台构成',
  'engagement_active_activeUsers_month_platform_distribution_title': '月活跃用户平台构成',
  // breakdown
  'engagement_active_activeUsers_breakdown_title': '国家/区域/区服排行榜',
  'engagement_active_activeUsers_breakdown_country': '国家',
  'engagement_active_activeUsers_breakdown_region': '区域',
  'engagement_active_activeUsers_breakdown_zone': '区服',
  'engagement_active_activeUsers_breakdown_country_name': '国家',
  'engagement_active_activeUsers_breakdown_region_name': '区域',
  'engagement_active_activeUsers_breakdown_zone_name': '区服',
  'engagement_active_activeUsers_breakdown_day_chart_title': '日活跃用户 Top 10',
  'engagement_active_activeUsers_breakdown_week_chart_title': '周活跃用户 Top 10',
  'engagement_active_activeUsers_breakdown_month_chart_title': '月活跃用户 Top 10',
  'engagement_active_activeUsers_breakdown_day_au_avg': '日平均活跃',
  'engagement_active_activeUsers_breakdown_week_au_avg': '周平均活跃',
  'engagement_active_activeUsers_breakdown_month_au_avg': '月平均活跃',
  'engagement_active_activeUsers_breakdown_day_au': '日活跃',
  'engagement_active_activeUsers_breakdown_week_au': '周活跃',
  'engagement_active_activeUsers_breakdown_month_au': '月活跃',
  'engagement_active_activeUsers_breakdown_share': '全局占比',
  'engagement_active_activeUsers_breakdown_share_table': '占比',
  'engagement_active_activeUsers_breakdown_date': '日期',
  // distribution
  'engagement_active_activeUsers_distribution_title': '活跃用户等级分布',
  'engagement_active_activeUsers_distribution_chart_title': '活跃用户',
  'engagement_active_activeUsers_distribution_date': '日期',
  'engagement_active_activeUsers_distribution_day_name': '日',
  'engagement_active_activeUsers_distribution_week_name': '周',
  'engagement_active_activeUsers_distribution_month_name': '月',
  'engagement_active_activeUsers_distribution_tab1': '聚合呈现',
  'engagement_active_activeUsers_distribution_tab2': '活跃用户 Top 10 等级',
  // role
  'engagement_active_activeUsers_role_count_title': '活跃角色计数',
  'engagement_active_activeUsers_role_date': '日期',

  'engagement_active_activeUsers_role_count_chart_title': '活跃角色',
  'engagement_active_activeUsers_role_count_day_legend1': '当天',
  'engagement_active_activeUsers_role_count_day_legend2': '上周同期',
  'engagement_active_activeUsers_role_count_day_legend3': '上周同期',
  'engagement_active_activeUsers_role_count_week_legend1': '当周',
  'engagement_active_activeUsers_role_count_week_legend2': '上月同期',
  'engagement_active_activeUsers_role_count_week_legend3': '上月同期',
  'engagement_active_activeUsers_role_count_month_legend1': '当月',
  'engagement_active_activeUsers_role_count_month_legend2': '去年同期',
  'engagement_active_activeUsers_role_count_month_legend3': '去年同期',

  'engagement_active_activeUsers_role_count_distribution_title': '活跃角色计数分布',
  'engagement_active_activeUsers_role_count_distribution_chart_title': '活跃用户',
  'engagement_active_activeUsers_role_count_distribution_legend1': '登录过1个角色',
  'engagement_active_activeUsers_role_count_distribution_legend2': '登录过2个角色',
  'engagement_active_activeUsers_role_count_distribution_legend3': '登录过3个角色',
  'engagement_active_activeUsers_role_count_distribution_legend4': '登录过4个角色',
  'engagement_active_activeUsers_role_count_distribution_legend5': '登录过5个及5个以上角色',
  // online analysis
  'engagement_active_online_avg_time_date': '日期',
  'engagement_active_online_avg_time_title': '平均在线时长',
  'engagement_active_online_avg_time_legend1': '平均在线时长（分钟）',
  'engagement_active_online_avg_time_legend2': '单次登录平均在线时长（分钟）',
  // overall online time
  'engagement_active_online_overall_date': '日期',
  'engagement_active_online_overall_title': '在线时间总体表现',
  'engagement_active_online_overall_dau': '日活跃',
  'engagement_active_online_overall_total': '总在线时长（分钟）',
  'engagement_active_online_overall_avg_online_time': '平均在线时长（分钟）',
  'engagement_active_online_overall_login_count': '登录次数',
  'engagement_active_online_overall_avg_online_time_per_login': '单次登录平均在线时长（分钟）',
  // online time distribution
  'engagement_active_online_distribution_title': '在线时长分布',
  'engagement_active_online_distribution_date': '日期',
  // online Average Online Time By Level
  'engagement_active_online_level_title': '平均在线时长等级分布',
  'engagement_active_online_level_date': '日期',
  // active degree
  'engagement_active_degree_weekly_activity_title': '活跃用户周登录行为',
  'engagement_active_degree_weekly_activity_chart_title': '{day}活跃用户数',
  'engagement_active_degree_weekly_activity_legend1': '当周',
  'engagement_active_degree_weekly_activity_legend2': '上周同期',
  'engagement_active_degree_weekly_activity_legend3': '所选周平均',
  'engagement_active_degree_weekly_activity_day': '{day}天',
  'engagement_active_degree_weekly_activity_date': '天',

  'engagement_active_degree_weekly_days_title': '用户周活跃天数',
  'engagement_active_degree_weekly_days_chart_title': '{day}活跃用户数',
  'engagement_active_degree_weekly_days_date': '天',
  'engagement_active_degree_weekly_days_login_au': '当天登录的活跃用户数',
  'engagement_active_degree_weekly_days_legend1': '1天',
  'engagement_active_degree_weekly_days_legend2': '2天',
  'engagement_active_degree_weekly_days_legend3': '3天',
  'engagement_active_degree_weekly_days_legend4': '4天',
  'engagement_active_degree_weekly_days_legend5': '5天',
  'engagement_active_degree_weekly_days_legend6': '6天',
  'engagement_active_degree_weekly_days_legend7': '7天',

  'engagement_active_degree_biweekly_activity_title': '活跃用户双周登录行为',
  'engagement_active_degree_biweekly_activity_chart_title': '登录的{day}',
  'engagement_active_degree_biweekly_activity_legend1': '双周活跃用户',
  'engagement_active_degree_biweekly_activity_day': '{day}天',
  'engagement_active_degree_biweekly_activity_date': '天',

  'engagement_active_degree_biweekly_days_title': '用户双周活跃天数',
  'engagement_active_degree_biweekly_days_chart_title': '登录的{day}',
  'engagement_active_degree_biweekly_days_login_au': '当天登录的活跃用户数',
  'engagement_active_degree_biweekly_days_date': '天',

  'engagement_active_degree_monthly_day': '第{day}天',
  'engagement_active_degree_monthly_date': '天',
  'engagement_active_degree_monthly_activity_title': '活跃用户月登录行为',
  'engagement_active_degree_monthly_activity_legend1': '当月',
  'engagement_active_degree_monthly_activity_legend2': '上月同期',
  'engagement_active_degree_monthly_days_title': '用户月活跃天数',
  'engagement_active_degree_monthly_activity_chart_title': '{day}登录的活跃用户',
  'engagement_active_degree_monthly_days_chart_title': '{day}登录的活跃用户',
  'engagement_active_degree_monthly_days_login_au': '当天登录的活跃用户数',

  // 为卡片 " Active User Trend Analysis 活跃用户趋势分析 " 准备
  'engagement_active_degree_active_user_trend_analysis_hover1': '高活跃',
  'engagement_active_degree_active_user_trend_analysis_hover2': '中活跃',
  'engagement_active_degree_active_user_trend_analysis_hover3': '低活跃',
  'engagement_active_degree_active_user_trend_analysis_legend1': '高活跃 (6~7 天)',
  'engagement_active_degree_active_user_trend_analysis_legend2': '中活跃 (3~5 天)',
  'engagement_active_degree_active_user_trend_analysis_legend3': '低活跃 (1~2 天)',
  'engagement_active_degree_active_user_trend_analysis_date': '日期',

  // 为卡片 " Weekly Active User Trend Analysis 活跃用户周趋势分析 " 准备
  'engagement_active_degree_weekly_active_user_trend_analysis_hover1': '高活跃',
  'engagement_active_degree_weekly_active_user_trend_analysis_hover2': '中活跃',
  'engagement_active_degree_weekly_active_user_trend_analysis_hover3': '低活跃',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend1': '高活跃 (6~7 天)',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend2': '中活跃 (3~5 天)',
  'engagement_active_degree_weekly_active_user_trend_analysis_legend3': '低活跃 (1~2 天)',
  'engagement_active_degree_weekly_active_user_trend_analysis_date': '日期',
}
